// extracted by mini-css-extract-plugin
export default {"alert":"AlertMessage_alert__81XVF","alertMessage":"AlertMessage_alertMessage__VQtzI","alertMessage__text":"AlertMessage_alertMessage__text__4EG1s"};